module.exports = __webpack_public_path__ + "img/book-tanakh.63642075.svg";